<template>
    <div>
        <vue-tags-input
            v-model="tag"
            :tags="value"
            :autocomplete-items="autocompleteItems"
            :add-only-from-autocomplete="true"
            @tags-changed="$emit('input', $event)"
        />
    </div>
</template>

<script>
import http from '@/http'
import FormGroup from '@/vendor/forms/FormGroups/Horizontal/FormGroup'
import VueTagsInput from '@johmun/vue-tags-input'

export default {
    components: {FormGroup, VueTagsInput},

    props: {
        'name': {},
        'value': {}
    },

    data() {
        return {
            tag: '',
            debounce: null,
            autocompleteItems: []
        }
    },

    watch: {
        tag() {
            if (this.tag.length === 0) return

            clearTimeout(this.debounce)

            this.debounce = setTimeout(() => {
                http.get('/api/v2/tags?filter[search]=' + this.tag)
                    .then(response => {
                        this.autocompleteItems = response.data.data.map(tag => {
                            return {
                                text: tag.attributes.name,
                                style: 'background-color:' + tag.attributes.color + ';color:#ffffff'
                            }
                        })
                    })
            }, 300)
        }
    }
}
</script>
